import { createSelector } from '@reduxjs/toolkit';

import type { CasinoConfigType } from '../../../api/fetchers/casinoConfig/types';
import type { Compliance, PlayerConfigType } from '../../../api/fetchers/playerConfig/types';
import { TableConfigType } from '../../../api/fetchers/tableConfig/types';
import type { CoreRootState } from '../../CoreStore';

import { AamsData, VideoConfig } from './types';

export const selectShouldMergeBonusBalance = createSelector(
  [
    (state: CoreRootState): Compliance | null => state.config?.compliance,
    (state: CoreRootState): CasinoConfigType | null => state.config.casinoConfig,
  ],
  (compliance, casinoConfig) => {
    if (!compliance || !casinoConfig) {
      return undefined;
    }
    return !((compliance?.displayBonusBalance || casinoConfig.showBonusBalance) && !casinoConfig.hideBonusBalance);
  }
);

export const selectPlayerConfig = (state: CoreRootState): PlayerConfigType | null => state.config.playerConfig;
export const selectPlayerConfigReady = (state: CoreRootState): boolean => state.config.playerConfigReady;
export const selectCompliance = (state: CoreRootState): Compliance | null => state.config.compliance;
export const selectJwtToken = ({ config }: CoreRootState): string | null => config.playerConfig?.jwtToken ?? null;

export const selectTableConfig = (state: CoreRootState): TableConfigType | null => state.config?.tableConfig;
export const selectTableConfigReady = (state: CoreRootState): boolean => state.config.tableConfigReady;

export const selectGsAddress = (state: CoreRootState): string | undefined => state.config.tableConfig?.gsAddress;
export const selectWsAddress = (state: CoreRootState): string | undefined => state.config.tableConfig?.wsAddress;

export const selectAamsData = (state: CoreRootState): AamsData | null => {
  return state.config.aamsData;
};

export const selectVideoConfig = (state: CoreRootState): VideoConfig | null | undefined => state.config.videoConfig;

export const selectVoiceOverEnabled = (isVoiceOverTable?: boolean) => {
  return (state: CoreRootState): boolean => {
    const disableVoiceOver = state.config?.compliance?.disableVoiceOverSound;
    const baseTableVOConfig = state.config?.tableConfig?.audioMode === 'on';
    const audioMode = isVoiceOverTable ?? baseTableVOConfig;

    return audioMode && !disableVoiceOver;
  };
};
